import BaseApplicationApi from 'client/api/v2/BaseApplicationApi';

class ApplicationTemplateApiV2 extends BaseApplicationApi {
  constructor() {
    super('/api/v2/application/catalog', {
      skip: 0,
      limit: 100,
      sort: 'name', // Prepend with a '-' to reverse default sort direction
      search: '',
    });
  }
}

export default new ApplicationTemplateApiV2();
